export enum Environment {
  SANDBOX = "sandbox",
  STAGING = "staging",
  PRODUCTION = "production"
}

export enum ServiceType {
  WALLET = "wallet",
  BACKTEST = "backtest"
}

export interface ApiConfig {
  baseURL: string;
  allowedOrigin: string;
}

export interface HttpConfig {
  timeout: number;
  deviceId: string;
  corsMethods: string;
  corsHeaders: string;
}

export interface ServicesConfig {
  wallet: string;
  backtest: string;
}

export interface ClientConfig {
  priceClientToken: string;
}

export interface Config {
  environment: Environment;
  api: ApiConfig;
  http: HttpConfig;
  services: ServicesConfig;
  client: ClientConfig;
}

export interface EnvironmentConfig {
  eddUrl: string;
  apiBaseUrl: string;
  name: Environment;
}
